import { FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useEffect } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import ErrorBoundary from '../../ErrorBoundary';

import { openedTab } from './slice';
import useHasBookmarks from './bookmarksBar/useHasBookmarksBar';

import Header from './header';
import Onboarding from './onboarding';

const BookmarksBar = lazy(() => import('./bookmarksBar'));

const User: FunctionalComponent = () => {
  const dispatch = useDispatch();
  const hasBookmarks = useHasBookmarks();

  useEffect(() => {
    dispatch(openedTab());
  }, []);

  return (
    <>
      <Header />

      <ErrorBoundary message={null} name="onboarding">
        <Onboarding />
      </ErrorBoundary>
    </>
  );
};

export default User;
